<template>
    <common-modal width="medium" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <div class="match-referral-cancellation-modal">
            <h2 class="match-referral-cancellation-modal__title">
                {{ modalTitle }}
            </h2>

            <p class="match-referral-cancellation-modal__description">
                {{ $t('pages.referrals.show.cancellation.match.description') }}
            </p>

            <div class="match-referral-cancellation-modal__actions">
                <common-button
                    :label="$t('pages.referrals.show.cancellation.match.buttons.no')"
                    type="secondary"
                    :disabled="isProcessing"
                    @click="emitEvent({ name: 'close' })"
                ></common-button>
                <common-button
                    :label="$t('pages.referrals.show.cancellation.match.buttons.yes')"
                    type="primary"
                    :isProcessing="isProcessing"
                    @click="confirm"
                ></common-button>
            </div>
        </div>
    </common-modal>
</template>

<script>
    export default {
        props: {
            referral: {
                type: Object,
                default: null,
            },
            isProcessing: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            patientFullName() {
                return `${this.referral?.patient?.firstName || ''} ${this.referral?.patient?.lastName || ''}`.trim()
            },
            modalTitle() {
                if (this.patientFullName) {
                    return this.$t('pages.referrals.show.cancellation.match.title', { name: this.patientFullName })
                }
                return this.$t('pages.referrals.show.cancellation.match.title_without_name')
            },
        },
        methods: {
            confirm() {
                this.emitEvent({
                    name: 'confirm',
                    payload: {
                        referralId: this.referral?.id,
                    },
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .match-referral-cancellation-modal {
        padding: 8px 0;
        color: #1f2937;
    }

    .match-referral-cancellation-modal__title {
        margin: 0 0 10px;
        font-size: 22px;
        line-height: 1.3;
        font-weight: 700;
        color: #1f2937;
    }

    .match-referral-cancellation-modal__description {
        margin: 0 0 24px;
        font-size: 14px;
        line-height: 1.5;
        color: #6b7280;
    }

    .match-referral-cancellation-modal__actions {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;

        margin-top: 24px;
        padding-top: 18px;

        border-top: 1px solid #f3f4f6;
    }
</style>
